module.exports = __webpack_public_path__ + "media/images/gift-card-baed56cdaff3ec199b5ffd4c2551941e.png";